import PropTypes from 'prop-types'

import {List} from 'immutable'
import {useEffect, useState} from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import {readEndpoint} from 'redux-json-api'

import MediumModal from './mui_base_components/modals/medium_modal/MediumModal'

import * as actionCreators from '../dashboard/src/components/corp_max/actions/corpMaxActionCreators'

import {Privacy} from './Links'

import './funeralHomeClientPrivacyNoticeModal.scss'

export const FuneralHomeClientPrivacyNoticeModal = ({
  items,
  linkText,
  ...otherProps
}) => {
  const [isOpen, setIsOpen] = useState(false)

  useEffect(() => {
    otherProps.readEndpoint('metadata/items').then(response => {
      otherProps.corpMaxActions.reshapeItems(response.body)
    })
  }, [])

  return (
    <div className='funeral-home-client-privacy-notice-modal'>
      <a onClick={() => setIsOpen(true)} role='button' tabIndex={0}>
        {linkText}
      </a>
      <MediumModal open={isOpen} onClose={() => setIsOpen(false)}>
        <h3 className='modal-title'>Privacy Notice</h3>
        <ol>
          <li>
            <h4 className='paragraph-title'>
              Funeral Home Partners (“FH Users”)
            </h4>
            <p className='paragraph'>
              If your Everplan is provided in connection with a participating
              funeral home, you acknowledge and agree that authorized
              representatives of that funeral home may access and view, edit,
              add, remove, and download the content of the following sections
              of your Everplan without requiring additional permission from
              you:
            </p>
            <ul>
              {
                items.map(item => (
                  <li key={item.get('id')}>{item.get('name')}</li>
                ))
              }
            </ul>
            <p className='paragraph'>
              They may also retain view access to these sections after your
              death for the purpose of coordinating arrangements and assisting
              Deputies. Any access to other parts of your Everplan requires
              your express consent.
            </p>
          </li>
          <li>
            <h4 className='paragraph-title'>
              Everplans Concierge (“Concierge”)
            </h4>
            <p className='paragraph'>
              The Concierge is a service that allows you to authorize a
              representative to assist you with your Everplan. You may grant
              permission for them to:
            </p>
            <ul>
              <li>
                View, edit, add, remove, and download the content from
                selected sections
              </li>
              <li>
                Add Deputies and share content on your behalf
              </li>
              <li>
                Request access to additional sections as directed by you
              </li>
            </ul>
            <p className='paragraph'>
              These permissions require explicit opt-in and can be revoked
              at any time through your account settings. All actions are
              logged for transparency, and you're responsible for any actions
              taken by someone you've granted access to.
            </p>
          </li>
        </ol>
        <p className='paragraph'>
          See the complete{' '}
          <Privacy target='_blank'>Everplans Privacy Policy</Privacy>.
        </p>
      </MediumModal>
    </div>
  )
}

FuneralHomeClientPrivacyNoticeModal.defaultProps = {
  linkText: 'Privacy notice'
}

FuneralHomeClientPrivacyNoticeModal.propTypes = {
  corpMaxActions: PropTypes.shape({
    reshapeItems: PropTypes.func
  }),
  editableItemIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  items: PropTypes.instanceOf(List).isRequired,
  linkText: PropTypes.string,
  readEndpoint: PropTypes.func.isRequired
}

const mapDispatchToProps = dispatch => ({
  corpMaxActions: bindActionCreators(actionCreators, dispatch),
  readEndpoint: bindActionCreators(readEndpoint, dispatch)
})

const mapStateToProps = (state, {editableItemIds}) => ({
  categories: state.categories,
  items: state.items.filter(item => editableItemIds.includes(item.get('id')))
})

export default connect(mapStateToProps, mapDispatchToProps)(FuneralHomeClientPrivacyNoticeModal)
